import deviceStateService from '@/services/device/deviceStateService';
import iccMarketService from '@/services/icc/iccMarketService';
import iccService from '@/services/icc/iccService';
import appRouterService from '@/services/route/appRouterService';
import storageService from '@/services/storage/storageService';
import {logoutClearData} from '@/state/slices/globalSlice';
import {dispatch} from '@/state/store';

import authDataStoreService from './authDataStoreService';

const login = async ({password, username}) => {
    authDataStoreService.setCredentials({username, password});

    try {
        await iccService.fetchIccToken();
    } catch (e) {
        throw e;
    }

    authDataStoreService.clearCredentials();
};

const logout = () => {
    storageService.removeAuthDataFromStorage();
    dispatch(logoutClearData());
    deviceStateService.clearDeviceState();

    appRouterService.forwardToLoginPage();
};

const requestOtpSmsCode = async ({phone, countryCode}) => {
    return iccMarketService.requestOtpCode({
        phone,
        countryCode,
    });
};

const requestOtpEmailCode = async ({email}) => {
    return iccMarketService.requestOtpCode({
        email,
    });
};

const verifyOtpCode = async ({code, token}) => {
    return iccService.verifyOtpCode({
        code,
        token,
    });
};

export default {
    logout,
    requestOtpSmsCode,
    requestOtpEmailCode,
    verifyOtpCode,
    login,
};
